import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ProdutoPizzaLasanhaQtdSabores, ProdutosComTamanhoRequest, Tamanho } from "../../models/produto.model";
import { ModalController } from "@ionic/angular";
import { ProdutoService } from "src/app/core/services/http/produto.service";
import { TamanhoService } from "src/app/core/services/http/tamanho.service";
import { forkJoin } from "rxjs";

@Component({
    selector: 'app-qtd-sabores-fatias',
    templateUrl: './qtd-sabores-fatias.component.html',
    styleUrls: ['./qtd-sabores-fatias.component.scss'],
})
export class QtdSaboresFatiasComponent implements OnChanges, OnInit {
    @Input() codigoCategoria = 0;
    @Input() produtoPizzaLasanhaQtdSabor: ProdutoPizzaLasanhaQtdSabores = new ProdutoPizzaLasanhaQtdSabores();
    @Input() tamanho: Tamanho = new Tamanho();

    // @Input() produtoPizzaLasanhaQtdFatias: ProdutoPizzaLasanhaQtdSabores = new ProdutoPizzaLasanhaQtdSabores();
    public produtoPizzaLasanhaQtdSaborSel: ProdutoPizzaLasanhaQtdSabores = new ProdutoPizzaLasanhaQtdSabores();
    public tamanhoSel: Tamanho = new Tamanho();

    constructor(
        private modalController: ModalController,
        private produtoService: ProdutoService,
        private tamanhoService: TamanhoService
    ) {

    }

    ngOnInit(): void {
        this.produtoPizzaLasanhaQtdSaborSel = this.produtoPizzaLasanhaQtdSabor;
        this.tamanhoSel = this.tamanho;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['produtoPizzaLasanhaQtdSabor']) {
            this.produtoPizzaLasanhaQtdSaborSel = this.produtoPizzaLasanhaQtdSabor;
        }
    }

    public fechar() {
        this.modalController.dismiss();
    }


    public confirmar() {
        var novoTamanho = ProdutosComTamanhoRequest.Get(this.tamanho.codigoCategoria, this.tamanho.tamanho);

        forkJoin({
            tamanho: this.tamanhoService.alterarProdutoTamanho(novoTamanho),
            produto: this.produtoService.alterarProdutosPizzaLasanhaQtdSabores(this.produtoPizzaLasanhaQtdSaborSel)
        }).subscribe({
            next: (res) => {
                this.fechar();
            },
            error: (err) => {
                console.error('Erro em alguma das requisições:', err);
            }
        });
    }
}